import React, { useEffect, useState } from "react";
import axios from "axios";
import Element_top_service from "../../components/topelementservice/Element_top_service";
import "./Recruit.scss";
import top_banner_service from "../../assets/img-partner/recruitment.webp";
import CardServiceNew from "../../components/cardservicenew/CardServiceNew";
import Pagination from "@mui/material/Pagination";
import usePaginations from "../../Paginations";
import Contant from "../../Contant";

const componentDidMount = () => {
  window.scrollTo(0, 0);
};

const Recruit = (props) => {
  componentDidMount();

  // /----------------------------------------/

  const [datas, setDatas] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios({
        method: "get",
        url: Contant + "api/posts?type=news",
        Headers: {
          Accept: "application.json",
          "Content-Type": "application/json",
        },
      });

      // response.data.news.recruit

      if (response.data.news.recruit === undefined) {
        setDatas(datas);
      } else {
        setDatas(response.data.news.recruit);
      }
    };
    fetchData();
  }, [props]);

  // /----------------------------------------/

  const getData = datas.find((item) => item.id);

  // get titile-id content

  const getContent = [];

  const content = "content";

  for (let list in getData) {
    if (list === content) {
      getContent.push(`${getData[list]}`);
    }
  }

  // get post detail

  function load_home(e) {
    (e || window.event).preventDefault();

    fetch("https://tiendungfinance.com.vn/api/data/contents/" + getContent)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("content").innerHTML = html;
      })
      .catch((error) => {
        console.warn(error);
      });
  }
  load_home();

  let [page, setPage] = useState(1);
  const PER_PAGE = 9;

  const count = Math.ceil(datas.length / PER_PAGE);
  var _DATA = usePaginations(datas, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div className="main_recruit">
      <Element_top_service
        question={"Bạn Cần Việc Làm ?"}
        request={"đăng ký ngay để nhận phỏng vấn ngay hôm nay !"}
        introduce={"Dịch vụ của chúng tôi"}
        last_introduce={
          "Tien Dung Finance cung cấp đa dạng các loại hình dịch vụ"
        }
        image={top_banner_service}
        className={"frame_img_banner_service_recruit"}
      />

      <div className="style_frame_main_card_newss">
        <div className="frame_service_item_new">
          {_DATA.currentDatas().map((item, index) => (
            <div key={index}>
              <CardServiceNew
                Title={item.title}
                image={
                  "https://tiendungfinance.com.vn/api/data/images/" +
                  item.coverPhoto
                }
                date={item.date}
                id={item.id}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="frame_piantion_news">
        <Pagination
          count={count}
          size="small"
          page={page}
          variant="outlined"
          shape="rounded"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default Recruit;
